 import { Card, Tag, Typography } from "antd";
import ImgOrIcon from "./ImgOrIcon";
import { money } from "../../utils/money";
import { useEffect } from "react";
const { Text } = Typography;

export type Modifier = {
  id: number;
  name: string;
  price_delta: number | string;
};
export type ModifierGroup = {
  id: number;
  name: string;
  required?: boolean;
  min_select?: number | null;
  max_select?: number | null;
  modifiers?: Modifier[];
};
export type Product = {
  id: number;
  name: string;
  price: number | string;
  image?: string | null;
  category_id: number;
  has_modifiers?: boolean;
  modifier_groups?: ModifierGroup[];
  modifierGroups?: ModifierGroup[];
};

export default function ProductGrid({
  products,
  onClick,
  palette,
  theme,
}: {
  products: Product[];
  onClick: (p: Product) => void;
  palette: {
    appBg: string;
    headerBg: string;
    headerBorder: string;
    leftBg: string;
    leftTextMuted: string;
    productBackground: string;
  };
  theme?: string;
}) {

  theme = theme || localStorage.getItem("pos.theme") || "light";
 
    useEffect(() => {
      localStorage.setItem("pos.theme", theme);
      const root = document.documentElement;
      if (theme === "dark") {
        root.classList.add("theme-dark");
        root.classList.remove("theme-light");
      } else {
        root.classList.add("theme-light");
        root.classList.remove("theme-dark");
      }
    }, [theme]);
  
  return (
    <div
      style={{
        height: "fit-content",
        overflow: "auto",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill,minmax(162px,1fr))",
        gap: 10,
        paddingRight: 4,
        paddingBottom: 10,
      }}
    >
      {products.map((p) => {
        // 🔁 normalizacija: uvijek imati .modifierGroups
        const modifierGroups: ModifierGroup[] = (p.modifierGroups ||
          p.modifier_groups ||
          []) as any[];

        const hasAnyGroups = modifierGroups?.length > 0;
      
        // klik: proslijedi proizvod sa .modifierGroups da bi modal radio
        const handleClick = () => {
          const normalized = p.modifierGroups ? p : { ...p, modifierGroups };
          onClick(normalized as Product);
        };

        return (
          <Card
            key={p.id}
            hoverable
            style={{
              borderRadius: 18,
              background: theme === "dark" ? palette.productBackground : palette.productBackground,
              border: "3px solid rgb(216 216 216)",
              height: "fit-content",
            }}
            bodyStyle={{ padding: 10 }}
            onClick={handleClick}
            cover={
              <div
                style={{
                  position: "relative",
                  padding: 10,
                  paddingBottom: 0,
                  color: theme === "dark" ? '#fff' : '#000',
                   borderRadius: 14,
                  height: "auto",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: -3,
                    right: -6,
                    borderRadius: 9999,
                    padding: "2px 8px",
                    fontWeight: 700,
                    background: theme === "dark" ? "rgb(243 192 183)" : "rgb(243 192 183)",
                    border: "1px solid #d6e4ff",
                  }}
                >
                  {money(p.price)} KM
                </div>
                <ImgOrIcon src={p.image || null} alt={p.name} height={50} />
              </div>
            }
          >
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <Text style={{ color: theme === "dark"?'#fff':'#000',fontWeight: 600,backgroundColor:palette.productBackground}} ellipsis>
                {p.name}
              </Text>
            
            </div>

            {/* TAG-ovi: stvarna imena grupa (crveni = obavezno, plavi = opcionalno).
               Ako nema grupa, ali BE kaže da ima modifikatore -> prikaži generički tag. */}
            {hasAnyGroups ? (
              <div
                style={{
                  marginTop: 6,
                  display: "flex",
                  gap: 4,
                  flexWrap: "wrap",
                }}
              >
                  <Tag
                    color={ "red" }
                  >
                   *modifikator
                  </Tag>
          
              </div>
            ) : <div
                style={{
                  marginTop: 6,
                  display: "flex",
                  gap: 4,
                  flexWrap: "wrap",
                }}
              >
                  <Tag
                    color={ "blue" }
                  >
                   *bez modifikatora
                  </Tag>
          
              </div>}
          </Card>
        );
      })}
    </div>
  );
}
